import { TextField } from "@mui/material";
import {
  DatePicker as DatePickerMui,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/pt-br";
import { Moment } from "moment";

interface RangeDatePickerProps {
  label: string;
  value: Moment | null;
  onChange: (date: Moment | null) => void;
  minDate?: Moment;
  maxDate?: Moment;
  ariaLabel?: string;
}

// Campo de data avulso (sem react-hook-form) usado no filtro de período do
// Dashboard. Espelha o estilo do components/DatePicker (raio 7px, altura 48,
// cores via CSS vars) para manter a identidade visual.
const RangeDatePicker = ({
  label,
  value,
  onChange,
  minDate,
  maxDate,
  ariaLabel,
}: RangeDatePickerProps) => {
  const customStyles = {
    "& .MuiInputBase-root": {
      borderRadius: "7px",
      height: 48,
      color: "var(--text)",
      backgroundColor: "var(--neutral-0)",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--border)",
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
      <label className="small fw-bold text-muted mb-1 d-block">{label}</label>
      <DatePickerMui
        value={value}
        inputFormat="DD/MM/YYYY"
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        DialogProps={{
          sx: {
            "& .MuiDialog-paper": {
              color: "var(--text)",
              backgroundColor: "var(--light)",
            },
            "& .MuiButtonBase-root": { color: "var(--primary)" },
            "& .MuiPickersDay-root": {
              color: "var(--text)",
              backgroundColor: "var(--white)",
            },
            "& .Mui-selected": {
              color: "var(--white)",
              backgroundColor: "var(--primary)",
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={customStyles}
            className="w-100"
            inputProps={{
              ...params.inputProps,
              placeholder: "dd/mm/aaaa",
              "aria-label": ariaLabel ?? label,
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default RangeDatePicker;
